import styled from 'styled-components';

const CheckboxWrapper = styled.div<{ $orange?: boolean }>`
  display: inline-block;
  position: relative;
  cursor: pointer;

  & input[type='checkbox']:checked {
    background: ${({ theme, $orange }) =>
      theme.colors[$orange ? 'orangePeel' : 'black']};
  }

  & input[type='checkbox']:checked + svg {
    transform: translate(-50%, -50%) scale(1);
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    transition: transform 0.3s ease;
    pointer-events: none;
  }
`;

const Input = styled.input<{
  $error?: boolean;
  $color?: string;
  $orange?: boolean;
}>`
  appearance: none;
  -webkit-appearance: none;
  display: flex;
  align-content: center;
  justify-content: center;
  border: 1px solid
    ${({ theme, $color, $orange }) =>
      $orange ? theme.colors.lineGrey : theme.colors[$color ?? 'black']};
  cursor: pointer;
  outline: none;
  border-radius: 5px;
  width: 1.8em;
  height: 1.8em;
  transition: all 0.3s ease;

  &:checked {
    border: 1px solid
      ${({ theme, $orange }) => $orange && theme.colors.orangePeel};
  }

  &:before {
    content: '';
    width: 100%;
    height: 100%;
    transition: transform 0.3s ease;
    transform: scale(0);
  }

  &:checked {
    border: 1px solid
      ${({ theme, $orange }) => $orange && theme.colors.orangePeel};
  }

  &:disabled {
    border: 1px solid ${({ theme }) => theme.colors.lineGrey};
    cursor: not-allowed;

    &:checked {
      border: 1px solid
        ${({ theme, $orange }) => $orange && theme.colors.orangePeel};
    }
  }

  ${({ $error, theme }) =>
    $error &&
    `
    border: 1px solid ${theme.colors.orangePeel};
  `}
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const S = {
  Input,
  CheckboxWrapper,
  CheckboxContainer,
};

export default S;
